<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 送货单表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="role_name === '外协商权限'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="handerSave"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="送货日期" required>
                 <el-date-picker v-if="formStatus" value-format="yyyy-MM-dd HH:mm" type="datetime" size="mini" placeholder="选择日期" clearable v-model="formData.delivery_date"></el-date-picker>
                 <span v-else>{{formData.delivery_date}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="样本册" required>
                <el-autocomplete v-if="formStatus" style="width: 100%"
                    popper-class="my-autocomplete"
                    v-model="formData.product_name"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入内容"
                    @select="handleSelect"
                    @blur="handblur"
                >
                  <i
                      class="el-icon-edit el-input__icon"
                      slot="suffix"
                      @click="handleIconClick">
                  </i>
                  <template slot-scope="{ item }">
                      <span>{{ item.name }}</span>
                  </template>
                </el-autocomplete>
                <span v-else>{{formData.product_name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="外协商">
                <span>{{formData.company_name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="送货单号">
                <el-input v-if="formStatus" placeholder="送货单号" v-model="formData.delivery_no" disabled></el-input>
                <span v-else>{{formData.delivery_no}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="送货人">
                <el-input v-if="formStatus" placeholder="送货人" v-model="formData.delivery_person"></el-input>
                <span v-else>{{formData.delivery_person}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="公司地址">
                <el-input v-if="formStatus" placeholder="公司地址" v-model="formData.delivery_address"></el-input>
                <span v-else>{{formData.delivery_address}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
            <div class="detail-title"><i class="em-icon-th-list"></i> 送货明细</div>
            <el-button v-if="formStatus" type="primary" size="mini" icon="el-icon-plus" round @click="addDetailhandler">添加送货明细</el-button>
            <el-button v-if="!formStatus && outsource_company_id !== '0'" type="primary" size="mini" icon="el-icon-printer" round @click="printHandler">打印二维码</el-button>
        </div>
        <div class="el-table-container form-details" style="top: 104px;">
          <div style="height: 100%;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="selectHandler">
              <el-table-column v-if="!formStatus && outsource_company_id !== '0'" type="selection" width="40" align="center"></el-table-column>
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="150" align="center"></el-table-column>
              <el-table-column label="台数" width="100" align="center">
                <template v-slot:default="scope">
                  <el-select :disabled="scope.row.base_material_name !== '台纸'" v-if="formStatus" size="mini" v-model="scope.row.table_number" placeholder="请选择" @change="tableNumberChange(scope.row)">
                    <el-option v-for="item in tableNumberArr" :key="item.value"  :label="item.value" :value="item.value"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.table_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="页码" width="100" align="center">
                <template v-slot:default="scope">
                  <el-select :disabled="scope.row.base_material_name !== '台纸'" v-if="formStatus" size="mini" v-model="scope.row.page" placeholder="请选择">
                    <el-option v-for="item in scope.row.pageArr" :key="item.value"  :label="item.value" :value="item.value"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.page}}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="100" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="数量" class="txtC" v-model="scope.row.number"></el-input>
                  <span v-else>{{scope.row.number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="实际送货数量" width="100" align="center">
                <template v-slot:default="scope">
                  <span>{{scope.row.fact_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="备注" v-model="scope.row.remark"></el-input>
                  <span v-else>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="60" align="center">
                <template v-slot:default="scope">
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelDetails(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
    <div id='print_area' style="position: relative; z-index: -1;">
      <div style="page-break-before: auto; page-break-after:always; text-align: center;" v-for="(item,index) in arrayPrint" :key="index" >
        <div style="font-size: 80px; margin-bottom: 50px;">{{item.product_name}}</div>
        <div ref=codeItem ></div>
        <div v-if="item.base_material_name !== '台纸'" style="font-size: 50px; margin-top: 30px;">部品：{{item.base_material_name}}</div>
        <div v-if="item.base_material_name === '台纸'" style="font-size: 50px; margin-top: 30px;">台数：{{item.table_number}}</div>
        <div v-if="item.base_material_name === '台纸'" style="font-size: 50px; margin-top: 30px;">页码：{{item.page}}</div>
        <div style="font-size: 50px; margin-top: 30px;">数量：{{item.number}}</div>
        <div style="font-size: 50px; margin-top: 30px;">送货日期：{{formData.delivery_date}}</div>
      </div>
    </div>
    <!-- 选择部件对话框 -->
    <ezz-dialog-product-part ref="productPartDialog" width="500px" :parent="this"></ezz-dialog-product-part>
  </el-dialog>
</template>
<script>
import QRCode from 'qrcodejs2'
import EzzDialogProductPart from '@/views/modules/delivery/DialogPart.vue'
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      index: 0,
      formEmptyData: {
        id: '0',
        product_id: '',
        product_name: '',
        delivery_no: '',
        delivery_date: '',
        company_id: '',
        company_name: '',
        delivery_person: '',
        delivery_address: '',
        remark: '',
        details: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      formDetailEmptyData: {
        id: '',
        delivery_id: '',
        base_material_id: '',
        base_material_name: '',
        table_number: '',
        page: '',
        number: '',
        remark: '',
        pages: '',
        pageArr: []
      },
      productList: [],
      product_check: '',
      tableNumberArr: [],
      selectedIds: [],
      arrayPrint: [],
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable,
      outsource_company_id: sessionStorage.getItem('outsource_company_id'),
      role_name: sessionStorage.getItem('role_name')
    }
  },
  beforeCreate: function () {
    let date = new Date()
    let month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    let day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
    var mins = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
    this.currentTime = date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 样本册搜索
    loadProduct: function () {
      let _this = this
      _this.get(_this.$apis.getInstoreProduct, {}, function (res) {
        _this.productList = res.data.dataList
      })
    },
    querySearchAsync: function (queryString, cb) {
      this.product_check = 'false'
      let results = queryString ? this.productList.filter(this.createStateFilter(queryString)) : this.productList

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 500 * Math.random())
    },
    createStateFilter: function (queryString) {
      return (product) => {
        return product.name.indexOf(queryString) > -1
      }
    },
    handleSelect: function (item) {
      let _this = this
      _this.product_check = 'true'
      _this.formData.product_name = item.name
      _this.formData.product_id = item.id
      _this.tableNumberArr = []
      _this.formData.details = []
      // 获取样本册对应台数
      _this.post(_this.$apis.getProductTable, { ProductId: _this.formData.product_id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          for (let i = 0; i < _json.tables.length; i++) {
            _this.tableNumberArr.push({ 'value': _json.tables[i] })
          }
        }
      })
    },
    handleIconClick: function (ev) {
      console.log(ev)
    },
    handblur: function () {
      if (this.product_check === 'false') {
        this.formData.product_name = ''
      }
    },
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getDeliveryForm, { DeliveryId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          if (_json.formData !== null) {
            _this.formData = _json.formData
            if (_json.tables !== null) {
              _this.tableNumberArr = []
              for (let i = 0; i < _json.tables.length; i++) {
                _this.tableNumberArr.push({ 'value': _json.tables[i] })
              }
            }
            if (_this.formData.details !== null) {
              for (let j = 0; j < _this.formData.details.length; j++) {
                if (_this.formData.details[j].pages !== null) {
                  let pages = _this.formData.details[j].pages.split(',')
                  _this.formData.details[j].pageArr = []
                  for (let i = 0; i < pages.length; i++) {
                    _this.formData.details[j].pageArr.push({ 'value': pages[i] })
                  }
                }
              }
            }
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.create_time = _this.currentDate
            _this.formData.delivery_date = _this.currentTime
            _this.formData.company_id = _this.outsource_company_id
            _this.post(_this.$apis.getCompanyName, { CompanyId: _this.outsource_company_id }, function (res) {
              let _json = res.data
              if (_json.status && _json.status === 'logout') {
                _this.logout()
              } else {
                _this.formData.company_name = _json.company_name
              }
            })
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    addHandler: function () {
      this.formData.id = '0'
      this.loadProduct()
      this.loadData()
      this.isShow = true
      this.formStatus = true
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadProduct()
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    // 添加明细
    addDetailhandler: function () {
      // let newDetail = JSON.parse(JSON.stringify(this.formDetailEmptyData))
      // this.formData.details.push(newDetail)
      if (this.formData.product_name === '') {
        this.$message({
          type: 'error',
          message: '请先选择样本册'
        })
        return
      }
      this.$refs.productPartDialog.open()
    },
    // 台数改变事件
    tableNumberChange: function (item) {
      let _this = this
      item.page = ''
      item.pageArr = []
      _this.post(_this.$apis.getProductPage, { ProductId: _this.formData.product_id, tableNumber: item.table_number }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          let pages = _json.pages.split(',')
          for (let i = 0; i < pages.length; i++) {
            item.pageArr.push({ 'value': pages[i] })
          }
        }
      })
    },
    // 打印二维码
    printHandler: function () {
      let _this = this
      let _ids = _this.selectedIds.join(',')
      if (_ids.length === 0) {
        _this.$message({
          type: 'warning',
          message: '至少选择一条数据'
        })
      } else {
        let content = ''
        for (let i = 0; i < _this.selectedIds.length; i++) {
          content += _this.selectedIds[i] + ','
        }
        _this.arrayPrint = _this.formData.details.filter(l => content.indexOf(l.id) > -1)
        for (let i = 0; i < _this.arrayPrint.length; i++) {
          _this.arrayPrint[i].product_name = _this.formData.product_name
        }
        _this.$nextTick(() => {
          _this.arrayPrint.forEach((item, index) => {
            let id = item.id
            _this.$refs.codeItem[index].innerHTML = ''
            // eslint-disable-next-line no-new
            new QRCode(_this.$refs.codeItem[index], {
              // 二维码内容
              text: id,
              width: 300,
              height: 300,
              // 二维码颜色
              colorDark: '#333333',
              // 二维码背景色
              colorLight: '#ffffff'
            })
          })
          setTimeout(() => {
            const style = '@page { margin-top: 200px } @media print { h1 { color: blue } img {margin: 0 auto;}}'
            _this.$print({
              printable: 'print_area',
              type: 'html',
              style: style,
              scanStyles: false
            })
          }, 200)
        })
      }
    },
    handlerDelDetails: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.details, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 多选事件
    selectHandler: function (selection) {
      this.selectedIds = []
      for (let i = 0; i < selection.length; ++i) {
        this.selectedIds.push(selection[i].id)
      }
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.delivery_date === '') {
          _this.$message({
            type: 'error',
            message: '送货日期不能为空'
          })
          return false
        }

        if (_mainData.product_name === '') {
          _this.$message({
            type: 'error',
            message: '样本册不能为空'
          })
          return false
        }

        if (_mainData.company_name === '') {
          _this.$message({
            type: 'error',
            message: '外协商不能为空'
          })
          return false
        }

        if (_mainData.details.length === 0) {
          _this.$message({
            type: 'error',
            message: '送货明细不能为空'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    handerSave: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveDeliveryForm, _this.formData, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _this.resetSetItem('new_delivery_count', _json.delivery_count)
              _this.viewHandler(_json.id)
              _this.parent.loadData()
            }
          }
        })
      }
    }
  },
  components: {
    EzzDialogProductPart
  }
}
</script>
